// Release stages type
type ReleaseStage = 'development' | 'staging' | 'production' | 'local';

// Static config type with environment functions
export type StaticConfig = {
  appAnalyticsName: string;
  appVersion: string;
  apiBaseURL: string;
  authEnvironment: string;
  appSwitcherProjectId: string;
  sentryDsn: string;
  deployedHost: string;
  environmentName: ReleaseStage;
  loginURL: string;
  logoutURL: string;
  twoFactorClientId: string;
  amplitudeApiKey: string;
  disableAuth: boolean;
  smartlingProjectId: string;
  tosUrl: string;
  discordUrl: string;
  portalUrl: string;
};

// Centralized static config with NextJS naming and cloud-console pattern
const staticConfig: StaticConfig = {
  appAnalyticsName: 'cx_support_hub',
  environmentName: process.env.NEXT_PUBLIC_ENVIRONMENT_NAME as ReleaseStage,
  appVersion: process.env.NEXT_PUBLIC_APP_VERSION ?? '',
  apiBaseURL: process.env.NEXT_PUBLIC_API_BASE_URL ?? '',
  authEnvironment: process.env.NEXT_PUBLIC_AUTH_ENVIRONMENT ?? '',
  appSwitcherProjectId: process.env.NEXT_PUBLIC_APP_SWITCHER_PROJECT_ID ?? '',
  sentryDsn: process.env.NEXT_PUBLIC_SENTRY_DSN ?? '',
  deployedHost: process.env.NEXT_PUBLIC_DEPLOYED_HOST ?? '',
  loginURL: process.env.NEXT_PUBLIC_LOGIN_URL ?? '',
  logoutURL: process.env.NEXT_PUBLIC_LOGOUT_URL ?? '',
  twoFactorClientId: process.env.NEXT_PUBLIC_TWO_FACTOR_CLIENT_ID ?? '',
  amplitudeApiKey: process.env.NEXT_PUBLIC_AMPLITUDE_KEY ?? '',
  disableAuth: process.env.NEXT_PUBLIC_DISABLE_AUTH === 'true',
  smartlingProjectId: process.env.NEXT_PUBLIC_SMARTLING_PROJECT_ID ?? '',
  tosUrl: process.env.NEXT_PUBLIC_TOS_URL ?? '',
  discordUrl: process.env.NEXT_PUBLIC_DISCORD_URL ?? '',
  portalUrl: process.env.NEXT_PUBLIC_PORTAL_URL ?? '',
};

// Helper functions
export function getStaticConfig(): StaticConfig {
  return staticConfig;
}

export function isLocal(): boolean {
  return staticConfig.environmentName === 'local';
}

export function isDevelopment(): boolean {
  return staticConfig.environmentName === 'development';
}

export function isStaging(): boolean {
  return staticConfig.environmentName === 'staging';
}

export function isProduction(): boolean {
  return staticConfig.environmentName === 'production';
}
